// import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import {
  Box,
  Flex,
  Heading,
  Spinner,
  useToast,
  // Text,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { newBorder, primary } from "../../../../utils/colors";
import ToastComponent from "../../../../components/partials/ToastComponent";
import { useTranslation } from "react-i18next";
// import SidePanel from "../../../../components/sidepanelNew/SidePanel";
// import useRoleCheck from "../../../../hooks/useRoleCheck";
import { useLocation, useParams } from "react-router-dom";
import useThemeColors from "../../../../hooks/useThemeColors";
import useScrollToTop from "../../../../hooks/useScrollToTop";
// import UserProfilePhoto from "./partials/UserProfilePhoto";
import UserProfileDetails from "./partials/UserProfileDetails";
import UserProfilePassword from "./partials/UserProfilePassword";
import UserProfileTenants from "./partials/UserProfileTenants";
// import FormControlGender from "../../../../components/input/FormControlGender";
// import FormControlDefault from "../../../../components/input/FormControlDefault";
// import FormControlDatePicker from "../../../../components/input/FormControlDatePicker";
// import ClinicCompanyDetails from "./partials/ClinicCompanyDetails";
// import ClinicLogo from "./partials/ClinicLogo";
// import ClinicDetails from "./partials/ClinicDetails";
// import ClinicSenderIdentities from "./partials/ClinicSenderIdentities";
// import ClinicRegionalSettings from "./partials/ClinicRegionalSettings";
// import ClinicDefaultEmployeeTreatmentPlans from "./partials/ClinicDefaultEmployeeTreatmentPlans";

const UserProfilePage = () => {
  useScrollToTop();

  // GENERAL
  const { slug } = useParams();
  const dispatch = useDispatch();
  const toastComponent = ToastComponent();
  const { t } = useTranslation();
  const toast = useToast();
  const location = useLocation();

  // COLORS
  const { whiteMode, backgroundLightMode, textPrimaryMode, newBorderMode } =
    useThemeColors();

  // ROLES
  // const isDoctor = useRoleCheck("employee_doctor");
  // const isAdmin = useRoleCheck("admin");

  // TAB BUTTONS
  // Button details for mapping
  //   const buttonDetails = [
  //     {
  //       label: t("clinicSettings.clinicInfo"),
  //       link: `/${slug}/settings/clinic-settings`,
  //       isDisabled: false,
  //     },
  //     {
  //       label: t("clinicSettings.activeModules"),
  //       link: `/${slug}/settings/clinic-settings/active-modules`,
  //       isDisabled: false,
  //     },
  //     {
  //       label: t("clinicSettings.paymentsInvoices"),
  //       link: `/${slug}/settings/clinic-settings/payments-and-invoices`,
  //       isDisabled: false,
  //     },
  //     {
  //       label: t("clinicSettings.tenantUsers"),
  //       link: `/${slug}/settings/clinic-settings/users`,
  //       isDisabled: false,
  //     },
  //   ];

  // STATE

  //  SIDEPANELS

  // REDUX
  const authLogin = useSelector((state) => state.authLogin);
  const { userInfo } = authLogin;

  const tenantDetailsBySlug = useSelector((state) => state.tenantDetailsBySlug);
  const { tenant } = tenantDetailsBySlug;

  // HANDLERS

  // FETCH DATA

  // USEEFFECT

  const isGoogleAccount = userInfo?.googleAccount || false;

  // LOGS
  // console.log("location.pathname", location.pathname);

  return (
    <>
      {/* HELMET START */}
      <Helmet>
        <title>{t("pageTitle.userProfilePage")}</title>
        <meta
          name="description"
          content={t("pageDescription.userProfilePage")}
        />
      </Helmet>
      {/* HELMET END */}

      {/* SIDEPANELS  START */}

      {/* SIDEPANELS  END */}

      {/* MODALS START */}
      {/* MODALS END */}

      {/* MAIN START */}
      {tenant ? (
        <Box w="100%" minH="100%" pt="80px">
          <Flex
            direction="column"
            w="100%"
            p={["1rem 0rem 6rem", "2rem 2rem 6rem"]}
          >
            <Box
              w="100%"
              h="100%"
              bg={whiteMode}
              // overflow="hidden"
              borderRadius="2rem"
            >
              {/* HEADER START */}
              <Flex
                w="100%"
                direction="column"
                p={["0rem 1.5rem 1rem", "0rem 2rem 1rem"]}
                m="0 0 0rem"
                borderBottom={`1px solid ${newBorder}`}
              >
                <Flex
                  w="100%"
                  align="center"
                  justify="space-between"
                  borderBottom={`0px solid ${newBorder}`}
                  p="2rem 0rem 0.5rem"
                >
                  <Heading fontSize="1.25rem" fontWeight="600">
                    {t("user.myProfile")}
                  </Heading>
                </Flex>
              </Flex>
              {/* HEADER END */}

              {/* MAIN LAYOUT START */}
              <Flex
                w="100%"
                direction="column"
                p={["0 0em 8rem", "0 2rem 8rem"]}
              >
                {/* <UserProfilePhoto
                  slug={slug}
                  tenant={tenant}
                  userInfo={userInfo}
                /> */}
                <UserProfileDetails
                  slug={slug}
                  tenant={tenant}
                  userInfo={userInfo}
                />

                {!isGoogleAccount && (
                  <UserProfilePassword
                    slug={slug}
                    tenant={tenant}
                    userInfo={userInfo}
                  />
                )}

                <UserProfileTenants
                  slug={slug}
                  tenant={tenant}
                  userInfo={userInfo}
                />

                {/* <ClinicLogo slug={slug} tenant={tenant} />
                <ClinicDetails slug={slug} tenant={tenant} />
                <ClinicCompanyDetails slug={slug} tenant={tenant} /> */}
                {/* <ClinicSenderIdentities tenant={tenant} /> */}
                {/* <ClinicRegionalSettings slug={slug} tenant={tenant} /> */}
                {/* <ClinicDefaultEmployeeTreatmentPlans
                  slug={slug}
                  tenant={tenant}
                /> */}
              </Flex>
              {/* MAIN LAYOUT  END */}
            </Box>
          </Flex>
        </Box>
      ) : (
        <Flex w="100%" h="100vh" align="center" justify="center">
          <Spinner size="xl" color={primary} />
        </Flex>
      )}
      {/* MAIN END */}
    </>
  );
};

export default UserProfilePage;
